import { render, staticRenderFns } from "./CardOffset.vue?vue&type=template&id=4754c69a&scoped=true&"
import script from "./CardOffset.vue?vue&type=script&lang=js&"
export * from "./CardOffset.vue?vue&type=script&lang=js&"
import style0 from "./CardOffset.vue?vue&type=style&index=0&id=4754c69a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4754c69a",
  null
  
)

export default component.exports